import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  svg {
    position: absolute;
    top: 13px;
    left: 11px;
    font-size: 19px;
    color: ${({ theme }) => theme.colors.grey.hitGrey};
    cursor: pointer;
  }
`;

export const SearchInput = styled.input`
  position: relative;
  border-color: ${({ theme }) => theme.colors.grey.light};
  width: 100%;
  box-sizing: border-box;
  border: 1px solid ${({ theme }) => theme.colors.grey.light};
  font-size: 16px;
  background-color: white;
  padding: 8px 20px 8px 40px;
  border-radius: 0px !important;
  font-family: ${({ theme }) => theme.fonts.montserrat};
  font-weight: 300;
  transition: width 10s;
  -webkit-transition: width 10s;
  &:focus {
    outline: none;
    box-shadow: none !important;
    border: 1px solid ${({ theme }) => theme.colors.primary} !important;
  }
`;
